import { v4 } from "uuid";
import { ISearchFilter } from "../../typings";
import { filters } from "./SearchFilters";
import { isDefaultFilter } from "../../util/isDefaultFilter";

const createDefaultFilters = () => {
  return filters
    ?.map((f) => {
      if (isDefaultFilter(f)) {
        return {
          ...f,
          index: v4(),
        };
      }
    })
    .filter((f) => f !== undefined) as ISearchFilter[];
};

let defaultFilters: undefined | ISearchFilter[];
export const getDefaultFilters = () => {
  if (!defaultFilters) {
    defaultFilters = createDefaultFilters();
  }
  return defaultFilters;
};

export const updateDefaultFilters = () => {
  defaultFilters = createDefaultFilters();
  return defaultFilters;
};
